<script setup lang="ts">
const LazyHydrationWrAccordion = defineLazyHydrationComponent('visible', () => import('~/components/molecules/WrAccordion.vue'));
const LazyHydrationWrAnimatedTraining = defineLazyHydrationComponent('visible', () => import('~/components/molecules/WrAnimatedTraining.vue'));
const LazyHydrationWrFromAugmentation = defineLazyHydrationComponent('visible', () => import('~/components/molecules/WrFromAugmentation.vue'));
const LazyHydrationWrPricing = defineLazyHydrationComponent('visible', () => import('~/components/molecules/WrPricing.vue'));
const LazyHydrationWrOfficialPartners = defineLazyHydrationComponent('visible', () => import('~/components/molecules/WrOfficialPartners.vue'));
const LazyHydrationWrSelectedProject = defineLazyHydrationComponent('visible', () => import('~/components/molecules/WrSelectedProject.vue'));
const LazyHydrationWrTailored = defineLazyHydrationComponent('visible', () => import('~/components/molecules/WrTailored.vue'));
const LazyHydrationWrTechUpgrade = defineLazyHydrationComponent('visible', () => import('~/components/molecules/WrTechUpgrade.vue'));
const LazyHydrationWrTestimonialCardCarousel = defineLazyHydrationComponent('visible', () => import('~/components/molecules/WrTestimonialCardCarousel.vue'));
const LazyHydrationWrDeveloper = defineLazyHydrationComponent('visible', () => import('~/components/molecules/WrDeveloper.vue'));
const LazyWrContactFormPopup = defineAsyncComponent(() => import('~/components/molecules/WrContactFormPopup.vue'));

const WrAnimatedTraining = defineAsyncComponent(
  () => import("~/components/molecules/WrAnimatedTraining.vue")
);

const colorMode = useColorMode();

const imageSrc = ref("/images/agile.webp");

onMounted(() => {
  imageSrc.value =
    colorMode.preference == "dark"
      ? "/images/agile-dark.webp"
      : "/images/agile.webp";
});
useHead({
  htmlAttrs: {
    lang: "en",
  },
  title: "Nuxt Development Services  – Certified Nuxt Partner Agency | WebReinvent",
  meta: [
    {
      name: "description",
      content:
        "WebReinvent offers expert Nuxt development services to build fast, SEO-friendly, and scalable web applications trusted by global brands.",
    },
    {
      name: "keywords",
      content:
        "Hire Nuxtjs Developers online, Remote Nuxtjs developers, Offshore Nuxtjs programmers, Dedicated Nuxtjs developers, Nuxtjs development company, Nuxtjs development services, Nuxtjs web development solutions, Nuxtjs development company",
    },
  ],
  link: [
    {
      rel: "preload",
      as: "image",
      href: "/images/agile-dark.webp",
      media: "(prefers-color-scheme: dark)",
    },
    {
      rel: "preload",
      as: "image",
      href: "/images/agile.webp",
      media: "(prefers-color-scheme: light)",
    },
  ],
});

const { isMobile, isDesktop } = useDevice();

const tabs = ref([
  { title: "Build A Software Product", active: true },
  { title: "Hire Nuxt Developer", active: false },
  { title: "Staff Augmentation", active: false },
]);

const handleTabClick = (index: any) => {
  tabs.value = tabs.value.map((tab, i) => ({
    ...tab,
    active: i === index,
  }));
  selectedTab.value = tabs.value.map((tab) => tab.active);

  console.log(selectedTab.value);
};

const selectedTab = ref<any>([]);

const solution = ref([
  {
    title: "VaahCMS",
    svg: "WrVaahCms",
    description:
      "VaahCMS is a web application development platform built with Laravel, Vue with structured (HMVC) Modules & Themes.",
    link: "https://vaah.dev/cms?utm_source=webreinvent.com&utm_medium=nuxt_page&utm_campaign=flash",
    iconAppendClass: "w-56 h-11"
  },
  {
    title: "VaahSaaS",
    svg: "WrVaahSaas",
    description:
      "VaahSaaS is a module for multi-tenancy, multi-database SaaS product development for VaahCMS.",
    link: "https://vaah.dev/saas?utm_source=webreinvent.com&utm_medium=nuxt_page&utm_campaign=flash",
    iconAppendClass: "w-56 h-11"
  },
  {
    title: "VaahFlutter",
    svg: "WrVaahFlutter",
    description:
      "Flutter scaffolding with essential and common functionalities to kick start the mobile app development.",
    link: "https://vaah.dev/flutter?utm_source=webreinvent.com&utm_medium=nuxt_page&utm_campaign=flash",
    iconAppendClass: "w-56 h-11"
  },
  {
    title: "VaahNuxt",
    svg: "WrVaahNuxt",
    description:
      "Build frontend Nuxt 3 and VaahCMS API. Shipped with Nuxt 3, FlowBite, Tailwind CSS and Pinia.",
    link: "https://vaah.dev/nuxt?utm_source=webreinvent.com&utm_medium=nuxt_page&utm_campaign=flash",
    iconAppendClass: "w-56 h-11"
  },
]);

const content = ref([
  {
    svg: "WrProductEng",
    title: "Reliable team <br /> of Developers",
    description: "More than 30+ Nuxt <br /> Certified Developers",
    link: "/services/development-services/product-engineering",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrVueJs",
    title: "Flexible and <br /> Scalable Code",
    description: "We follow industry standard coding guidelines.",
    link: "#",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrEcommerce",
    title: "Automated Code <br /> Deployment",
    description: "New releases are auto deployed using CI/CD.",
    link: "#",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrCmsDev",
    title: "Google PageSpeed Faster <br /> (> 90)",
    description: "We guarantee 3 sec page load time or less",
    link: "#",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrAppDev",
    title: "Google and<br /> Core Vitals",
    description: "For Better Website Performance",
    link: "#",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrMobileAppDev",
    title: "Can handle<br /> heavy traffic",
    description: "None of our developers will have production credentials",
    link: "#",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrApiDev",
    title: "Automated <br /> Testing",
    description:
      "Each release will be test <br /> using automated test scripts.",
    link: "#",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrMVPDev",
    title: "SEO <br /> Friendly",
    description: "Boosting your website's SEO with effective strategies",
    link: "#",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrAppDev",
    title: "HIPAA-Compliant <br /> Software",
    description: "Only few companies can build HIPAA-Compliant Softwares",
    link: "#",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrMobileAppDev",
    title: "Global Ultra <br /> Low Latency",
    description:
      "Yes, we do all of that. We're very detailed and process oriented",
    link: "#",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrApiDev",
    title: "Free Software <br /> Training Video",
    description:
      "We teach you how to effective use the software and all the features",
    link: "#",
    iconAppendClass: 'size-11'
  },
  {
    svg: "WrMVPDev",
    title: "Live Training <br /> Sessions",
    description:
      "We’ll always be there to help you to address your queries live",
    link: "#",
    iconAppendClass: 'size-11'
  },
]);

const augmentation = ref([
  {
    title: "Product Engineering",
    description:
      "We offer end-to-end enterprise product development & integration.",
  },
  {
    title: "Vue Development",
    description: "Turn your ideas into competitive business solutions.",
  },
  {
    title: "eCommerce Development",
    description: "We create custom eCommerce applications for exceptional UX.",
  },
  {
    title: "CMS Development",
    description: "Offers secure, flexible, and efficient CMS.",
  },
]);

const devInfo = ref([
  {
    img: "/images/dev-1.webp",
    name: "Vikram Chand",
    exp: "10+ Years of experience in",
    tech: ["WrLaravel", "WrNuxt", "WrVue", "WrFlutter", "WrReact"],
  },
  {
    img: "/images/dev-2.webp",
    name: "Rahul Dev",
    exp: "8+ Years of experience in",
    tech: ["WrLaravel", "WrNuxt", "WrVue", "WrFlutter", "WrReact"],
  },
  {
    img: "/images/dev-3.webp",
    name: "Satyajeet Singh Sanu",
    exp: "7+ Years of experience in",
    tech: ["WrLaravel", "WrNuxt", "WrVue", "WrFlutter", "WrReact"],
  },
  {
    img: "/images/dev-4.webp",
    name: "Himanshu Rai",
    exp: "5+ Years of experience in",
    tech: ["WrLaravel", "WrNuxt", "WrVue", "WrFlutter", "WrReact"],
  },
  {
    img: "/images/devs.webp",
    name: "+25 More",
    exp: "",
    tech: ["WrLaravel", "WrNuxt", "WrVue", "WrFlutter", "WrReact"],
  },
]);

const staffAchivements = ref([
  { count: "100+", title: "Trained IT Professional" },
  { count: "40+", title: "Nuxt Developer" },
  { count: "60+", title: "Frontend, UI/UX, DevOps, Testers" },
  { count: "10+", title: "Agencies hired from us" },
]);

const staffSpecs = ref([
  {
    svg:"WrBadge",
    title: "Senior Nuxt Certified Developer",
     appendClass: "size-11"
  },
  {
    svg:"WrTeam",
    title: "Scale your team in matter of days",
     appendClass: "size-11"
  },
  {
    svg:"WrCmsDev",
    title: "Indepth knowledge of Nuxt Ecosystem",
     appendClass: "size-11"
  },
  {
    svg:"WrMicroService",
    title: "Build monolithic or micro services architecture",
     appendClass: "size-11"
  },
]);

const oldVersion = ref([
  {
    title: "Nuxt 2",
    version: "",
    background: "bg-[#48169E]",
  },
]);

const newVersion = ref([
  {
    title: "Nuxt 3",
    version: "",
    background: "bg-[#FF2D20]",
  },
]);

const projects = ref([
  {
    id: "01",
    title: "Real time",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "02",
    title: "Order Management",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "03",
    title: "Analytic",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "04",
    title: "Leaning Management System",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "05",
    title: "Live Streaming",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
]);

const outsource = ref([
  {
    id: "01",
    text: "Cost Effective Development <br> $30 (India) vs $80 (USA)",
  },
  {
    id: "02",
    text: "Most people in India are <br> comfortable in speaking English",
  },
  {
    id: "03",
    text: "Strong work ethic and dedication <br> to delivering high-quality work",
  },
  {
    id: "04",
    text: "Highly Skilled and hard working developers <br> familiar, with the latest technologies",
  },
]);

const categories = ref([
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/zack.webp",
  },
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/ankur.webp",
  },
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/taffain.webp",
  },
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/zack.webp",
  },
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/taffain.webp",
  },
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/ankur.webp",
  },
]);

// Responsive settings for the carousel
const responsiveOptions = ref([
  { breakpoint: "1400px", numVisible: 3, numScroll: 1 }, // For extra-large screens
  { breakpoint: "1200px", numVisible: 3, numScroll: 1 }, // For large screens
  { breakpoint: "992px", numVisible: 3, numScroll: 1 }, // For medium screens
  { breakpoint: "768px", numVisible: 2, numScroll: 1 }, // For smaller tablets
  { breakpoint: "576px", numVisible: 1, numScroll: 1 }, // For mobile screens
]);

const formData = ref({
  selectedUpgradeFrom: null,
  selecetedUpgradeTo: null,
  businessEmail: null,
});

const submitForm = () => {
  openModal([formData.value]);
};

const preVer = ref([{ label: "Nuxt 2" }]);

const latestVer = ref([{ label: "Nuxt 3" }]);

const items = [
  "All",
  "Pricing & Value",
  "Experience & Expertise",
  "Collaboration & Communication",
  "Company Information",
];
const activeIndex = ref(0);

const setActive = (index: any) => {
  activeIndex.value = index;
};

const accordionContent = ref([
  {
    title:
      "What makes Nuxt a good choice when compared with other front-end frameworks?",
    description:
      "Nuxt is a modern, progressive framework that makes it easy to create powerful web applications with a single-page and fast to build, which makes it fantastic for SEO. It's the fastest framework available and is powerful enough to offer outstanding UI and UX in SPAs.",
    tags: ["All", "Company Information", "Experience & Expertise"],
  },
  {
    title: "Do you have an existing app and want to upgrade or fix it in Nuxt?",
    description:
      "With us, you can share the codebase of your current application and we'll fix all bugs, improve performance, add new features you need to work more efficiently.",
    tags: ["All", "Experience & Expertise", "Collaboration & Communication"],
  },
  {
    title:
      "If I hire dedicated Nuxt developers for my project, will they work for me exclusively?",
    description:
      "We avoid conflicts by ensuring that our employees never work on two projects at the same time. That means that if you choose a dedicated team model, your project will be the expert's only focus and they won't have to worry about burning out or switching to another project which may delay your deadline.",
    tags: ["All", "Collaboration & Communication", "Company Information"],
  },
  {
    title:
      "Will you continue to provide support after Nuxt web app development is completed?",
    description:
      "Every project we finish comes with complete support and consultation service. But this doesn't last forever. If you need any help after the fixed period, we offer affordable plans as well.",
    tags: ["All", "Collaboration & Communication", "Pricing & Value"],
  },
  {
    title:
      "What means of communication are available to us if we need to get in touch with hired developers?",
    description:
      "WebReinvent provides several communication modes for you to coordinate with your hired vue developers: Skype, Teams, Email, Meet and Zoom.",
    tags: ["All", "Collaboration & Communication", "Company Information"],
  },
  {
    title: "How much does it cost to build an application in Nuxt?",
    description:
      "The cost of creating a Next website or application is obviously dependent on its complexity. From a simple personal website, to something like a business site with multiple pages and any number of elements, there are various factors which influence the cost.",
    tags: ["All", "Pricing & Value", "Company Information"],
  },
]);
const filteredAccordionContent = computed(() => {
  const selectedTag = items[activeIndex.value];
  return accordionContent.value.filter((item) =>
    item.tags.includes(selectedTag)
  );
});

const pricingContent = ref([
  {
    planTypeIcon: "WrClock",
    appendClass: "size-12",
    planLabel: "Hire on",
    billingType: "HOURLY BASIS",
    priceAmount: "$30",
    featuresList: [
      "On-Demand Model",
      "Flexibility and Scalability",
      "Focus on Core Activities",
      "Dedicated Professionals",
    ],
    ctaText: "Get started",
    highlightNote: "• Limited time offer •",
  },
  {
    planTypeIcon: "WrStarShield",
    appendClass: "size-[43px]",
    planLabel: "Hire on",
    billingType: "MONTHLY BASIS",
    priceAmount: "$3500",
    featuresList: [
      "Priority Support",
      "Custom Team",
      "Ongoing Updates",
      "Flexible Terms",
    ],
    ctaText: "Get started",
    highlightNote: "• Limited time offer •",
  },
  {
    planTypeIcon: "WrCalender",
    appendClass: "size-[45px]",
    planLabel: "Hire a",
    billingType: "SCRUM TEAM",
    priceAmount: "$15000",
    featuresList: [
      "Full Team",
      "Agile Process",
      "Scalable Delivery",
      "Sprint Reports",
    ],
    ctaText: "Get started",
    highlightNote: "• Limited time offer •",
  },
]);
const visible = ref(false);
const formPrefilledData = ref(null);

const openModal = (prefilledValue = null) => {
  if (prefilledValue == null) formPrefilledData.value = null;
  else if (prefilledValue.length) formPrefilledData.value = prefilledValue;
  visible.value = true;
};
const handleButtonClick = () => {
  openModal();
};

const openWithEmitVariable = (type: string) => {
  formPrefilledData.value = type;
  visible.value = true;
};

// const preVer = ref(["Laravel 5", "Laravel 5.1", "Laravel 5.2", "Laravel 5.3", "Laravel 5.4", "Laravel 5.5", "Laravel 5.6", "Laravel 5.7", "Laravel 5.8", "Laravel 6", "Laravel 7", "Laravel 8"]);
// const latestVer = ref(["Laravel 9", "Laravel 10", "Laravel 11"]);
</script>

<template>
  <div
    class="z-10 relative dark:bg-[linear-gradient(109.63deg,#0C0226_3.67%,#1C0035_83.91%)]"
  >
    <section
      class="relative z-10 py-10 lg:py-32 overflow-visible grid place-items-center"
    >
      <div class="max-w-screen-xl mx-auto px-4 w-full relative">
        <div
          class="size-[1200px] rounded-full bg-[image:var(--bg-circle-light)] absolute -top-[115%] -left-[40%] dark:shadow-[49px_11px_53.1px_15px_#130230]"
        ></div>
        <div
          class="size-[428px] opacity-60 bg-[#AE45AA80] rounded-full absolute top-[70%] -translate-y-1/2 -left-[30%] blur-[300px]"
        ></div>
        <div
          class="size-[428px] opacity-60 bg-[image:var(--bg-circle-hero-sm)] rounded-full absolute bottom-0 -right-[30%]"
        ></div>

        <div class="z-10 relative">
          <h1 class="text-center mb-8 lg:mb-16 text-3xl lg:text-[78px]">
            <WrGradientText
              text="Official Nuxt partner"
              append-class="max-lg:py-0 lg:pb-10"
            />
            <span class="">enterprise solutions built to scale.</span>
          </h1>
          <p
            class="text-base md:text-xl text-center max-w-3xl px-2 mx-auto mb-20 tracking-[0.5px]"
          >
            If you're looking for a team of <strong>Nuxt experts</strong> to
            build an API, an application, provide consultation or code audits,
            we've got you covered.
          </p>

          <div
            class="max-w-4xl px-2 mx-auto mb-20 tracking-[0.5px] text-center"
          >
            <p class="mb-6 text-2xl">What we offer for free:</p>
            <ul
              class="flex max-sm:flex-col justify-around text-base gap-4 text-left *:max-w-max mx-auto max-w-max"
            >
              <li
                class="flex gap-2 items-center dark:border bg-white dark:bg-transparent px-4 py-0.5 max-sm:text-sm sm:py-2 rounded-full dark:border-white/40 border-black/40"
              >
                <video autoplay loop muted playsinline width="34" height="34">
                  <source src="/images/blue-tick.webm" type="video/webm" />
                </video>
                30 Min Consultation
              </li>
              <li
                class="flex gap-2 items-center dark:border bg-white dark:bg-transparent px-4 py-0.5 max-sm:text-sm sm:py-2 rounded-full dark:border-white/40 border-black/40"
              >
                <video autoplay loop muted playsinline width="34" height="34">
                  <source src="/images/blue-tick.webm" type="video/webm" />
                </video>
                1000 Line of Code Audit
              </li>
              <li
                class="flex gap-2 items-center dark:border bg-white dark:bg-transparent px-4 py-0.5 max-sm:text-sm sm:py-2 rounded-full dark:border-white/40 border-black/40"
              >
                <video autoplay loop muted playsinline width="34" height="34">
                  <source src="/images/blue-tick.webm" type="video/webm" />
                </video>
                Performance Benchmarking
              </li>
            </ul>
          </div>
          <picture>
            <source :srcset="imageSrc" type="image/webp" />
            <img
              :src="imageSrc"
              alt="Agile development banner"
              class="block mx-auto"
              width="777"
              height="458"
              fetchpriority="high"
            />
          </picture>
        </div>
      </div>
    </section>

    <section
      class="relative z-10 pb-10 lg:pb-24 overflow-hidden grid place-items-center"
    >
      <div class="max-w-screen-xl mx-auto px-4 w-full">
        <h2 class="text-center mb-16">
          <WrGradientText
            text="Create powerful SaaS solutions with Nuxt"
            append-class="pb-4"
          />
          <p class="text-lg max-w-4xl mx-auto tracking-[0.5px] lg:px-4">
            Use VaahCLI to accelerate your workflow with quick installations,
            scaffolding modules, themes, CRUD, migrations, models, views, and
            more—all with simple commands.
          </p>
        </h2>

        <div
          class="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-7 *:w-full *:h-full"
        >
          <div
            v-for="(product, index) in solution"
            :key="index"
            class="gradient-border-mask relative p-px dark:before:bg-[linear-gradient(91.95deg,_rgba(61,27,96,0.5)_4.5%,_rgba(63,22,104,0.5)_96.91%)] before:bg-[linear-gradient(91.95deg,_rgba(182,164,199,0.5)_4.5%,_rgba(148,103,192,0.5)_96.91%)]"
          >
            <Card
              unstyled
              class="p-4 md:p-7 relative dark:bg-none bg-[var(--color-5)] dark:bg-transparent text-[var(--primary)] text-sm h-full rounded-xl"
            >
              <template #title>
                <component
                  :is="product.svg"
                  class="mb-4 text-[var(--foreground)]"
                />
                <WrSVGIcon :name="product.svg"  class="mb-4 text-[var(--foreground)] mx-auto !block" :class="product.iconAppendClass"/>
              </template>
              <template #content>
                <p class="m-0">{{ product.description }}</p>
                <NuxtLink
                  :to="product.link"
                  target="_blank"
                  class="absolute z-10 block size-full inset-0"
                  :aria-label="`View details for ${product.title}`"
                />
              </template>
            </Card>
          </div>
        </div>
        <WrButton @click="handleButtonClick" container-class="mx-auto mt-6"
          >Schedule a Demo</WrButton
        >
      </div>
    </section>
    <div
      class="flex gap-8 text-sm md:text-lg font-normal max-w-max mx-auto mb-14 px-4"
    >
      <p
        v-for="(tab, index) in tabs"
        :key="tab.title"
        :aria-selected="tab.active"
        :class="
          tab.active
            ? 'max-sm:text-sm text-[var(--primary)] dark:text-white font-semibold border-b-4 !pb-3 !p-0 selected_tab after:aria-selected:top-[100%]'
            : 'text-[#838385] dark:text-[#6950AA] cursor-pointer'
        "
        @click="handleTabClick(index)"
      >
        {{ tab.title }}
      </p>
    </div>
    <div class="flex flex-col">
      <!-- Section 1: Build with Laravel Partner -->
      <section
        class="relative z-10 pb-10 lg:pb-24 overflow-hidden grid place-items-center"
        :class="selectedTab[0] ? 'order-1' : 'order-2'"
        id="`panel-0`"
        role="tabpanel"
        :aria-labelledby="`tab-0`"
      >
        <div class="max-w-screen-xl mx-auto px-10 w-full">
          <h2 class="text-center mb-16">
            <WrGradientText
              text="Build with Nuxt Partner"
              append-class="pb-4"
            />
            <p class="text-lg max-w-3xl mx-auto tracking-[0.5px]">
              Save time and reduce costs with a certified Nuxt Partner Company.
              Jumpstart development using our open-source tools like VaahSaaS,
              VaahStore, and more.
            </p>
          </h2>
          <div class="relative">
            <div
              class="grid max-sm:max-w-[350px] mx-auto max-sm:place-content-left sm:grid-cols-2 lg:grid-cols-4 relative"
            >
              <!-- <div
                                class="max-sm:hidden flex justify-between pointer-events-none absolute top-0 w-full h-full">
                                <div v-for="i in 5"
                                    class="h-full w-px even:bg-[linear-gradient(180deg,rgba(255,255,255,0.12)_-0.89%,#E1B8FF_100%)] bg-[linear-gradient(0deg,rgba(255,255,255,0.12)_-0.89%,#E1B8FF_100%)] dark:bg-[linear-gradient(180deg,rgba(255,255,255,0.12)_-0.89%,rgba(255,255,255,0)_100%)] dark:even:bg-[linear-gradient(0deg,rgba(255,255,255,0.12)_-0.89%,rgba(255,255,255,0)_100%)] max-lg:even:hidden ">
                                </div>
                            </div> -->

              <LazyHydrationWrTailored :content="content" variant="secondary"  :hydrate-on-visible="{ rootMargin: '100px' }"/>
            </div>

            <WrButton
              @click="handleButtonClick"
              container-class="mx-auto mt-6 z-10 relative"
              >Connect with us</WrButton
            >
          </div>
        </div>
      </section>

      <section
        class="relative z-10 pb-20 lg:pb-32 grid place-items-center order-3"
      >
        <div class="max-w-screen-xl mx-auto px-4 w-full">
          <div
            class="size-[428px] opacity-60 bg-[#AE45AA80] rounded-full absolute top-[50%] left-1/2 -translate-x-1/2 blur-[300px]"
          ></div>
          <h2 class="text-center">
            <WrGradientText
              text="Multi-Tenancy Made Simple"
              append-class="py-0 lg:pb-4"
            />
            <p class="text-3xl lg:text-[48px]">
              Scale Thousands of Databases Effortlessly
            </p>
          </h2>
          <p
            class="mt-6 text-lg max-w-4xl mx-auto text-center tracking-[0.5px]"
          >
            Use the API to deploy database multi-tenant architectures. Scale to
            fleets of thousands of databases without touching a server. Rest
            easy knowing scale to zero keeps costs low.
          </p>
          <NuxtImg
            src="/images/agile.webp"
            alt="agile"
            width="777"
            height="458"
            class="mx-auto mt-12"
            loading="lazy"
            format="webp"
          />
       
          <LazyHydrationWrOfficialPartners
            append-class="mt-8 md:mt-16"
            :title="'Official Partner Of'"
            :partnersAppendClass="'justify-center items-center'"
            :hydrate-on-visible="{ rootMargin: '100px' }"
          />
        </div>
        <!-- Why choose us -->
        <div class="max-w-screen-xl mx-auto px-4 pt-14">
          <h2 class="text-center">
            <WrGradientText text="Why Choose Us?" append-class=" py-0" />
          </h2>
          <p
            class="mt-4 text-lg max-w-4xl mx-auto text-center tracking-[0.5px]"
          >
            Exemplified exceptional proficiency in delivering outstanding
            <strong>Nuxt development services</strong>.
          </p>
          <div class="py-8">
            <div class="max-w-7xl mx-auto px-6">
              <!-- Top Stats -->
              <div
                class="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center mb-12"
              >
                <div>
                  <h3 class="text-3xl font-bold text-[var(--primary)]">15+</h3>
                  <p class="text-gray-700 dark:text-white/50">Years</p>
                </div>
                <div>
                  <h3 class="text-3xl font-bold text-[var(--primary)]">800+</h3>
                  <p class="text-gray-700 dark:text-white/50">Projects</p>
                </div>
                <div>
                  <h3 class="text-3xl font-bold text-[var(--primary)]">20+</h3>
                  <p class="text-gray-700 dark:text-white/50">Countries</p>
                </div>
                <div>
                  <h3 class="text-3xl font-bold text-[var(--primary)]">100+</h3>
                  <p class="text-gray-700 dark:text-white/50">Developers</p>
                </div>
              </div>

              <!-- Bottom Feature Boxes -->
              <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                <div
                  class="bg-[image:var(--border-staff-card)] rounded-xl h-full text-white shadow-md relative p-px"
                >
                  <div
                    class="py-6 px-4 rounded-xl text-center bg-[image:var(--bg-staff-card)] h-full"
                  >
                    <p class="text">
                      Extensive Expertise<span class="font-semibold">Nuxt</span>
                    </p>
                  </div>
                </div>
                <div
                  class="bg-[image:var(--border-staff-card)] rounded-xl h-full text-white shadow-md relative p-px"
                >
                  <div
                    class="py-6 px-4 rounded-xl text-center bg-[image:var(--bg-staff-card)] h-full"
                  >
                    <p class="text">
                      In depth Knowledge of
                      <span class="font-semibold">Laravel, Vue & Nuxt</span>
                    </p>
                  </div>
                </div>
                <div
                  class="bg-[image:var(--border-staff-card)] rounded-xl h-full text-white shadow-md relative p-px"
                >
                  <div
                    class="py-6 px-4 rounded-xl text-center bg-[image:var(--bg-staff-card)] h-full"
                  >
                    <p class="text">
                      Prebuild
                      <span class="font-semibold">Nuxt Frontend</span> for
                      faster development
                    </p>
                  </div>
                </div>
                <div
                  class="bg-[image:var(--border-staff-card)] rounded-xl h-full text-white shadow-md relative p-px"
                >
                  <div
                    class="py-6 px-4 rounded-xl text-center bg-[image:var(--bg-staff-card)] h-full"
                  >
                    <p class="text">
                      Detailed timesheet with
                      <span class="font-semibold">Git commits</span> and demos
                    </p>
                  </div>
                </div>
                <div
                  class="bg-[image:var(--border-staff-card)] rounded-xl h-full text-white shadow-md relative p-px"
                >
                  <div
                    class="py-6 px-4 rounded-xl text-center bg-[image:var(--bg-staff-card)] h-full"
                  >
                    <p class="text">
                      Real-time <span class="font-semibold">Updates</span> on
                      <span class="font-semibold">Project progress</span>
                    </p>
                  </div>
                </div>
                <div
                  class="bg-[image:var(--border-staff-card)] rounded-xl h-full text-white shadow-md relative"
                >
                  <div
                    class="py-6 px-4 rounded-xl text-center bg-[image:var(--bg-staff-card)] h-full"
                  >
                    <p class="text">
                      Efficient and
                      <span class="font-semibold">Development Process</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Section 2: Hire Certified Laravel Professionals -->
      <section
        class="relative z-10 pb-10 lg:pb-24 grid place-items-center"
        :class="selectedTab[1] ? 'order-1' : 'order-4'"
        id="`panel-1`"
        role="tabpanel"
        :aria-labelledby="`tab-1`"
      >
        <div class="max-w-screen-xl mx-auto px-4 w-full">
          <div
            class="max-sm:hidden size-[598px] bg-[#AE45AA]/10 rounded-full absolute top-[20%] left-0 -translate-x-1/2 blur-[80px]"
          ></div>
          <h3 class="text-center">
            <WrGradientText
              text="Hire Certified Nuxt Professionals"
              append-class="py-0 lg:py-4"
            />
            <p class="text-3xl lg:text-[48px]">For Scalable Solutions</p>
          </h3>
          <p
            class="mt-6 text-lg max-w-3xl mx-auto text-center tracking-[0.5px]"
          >
            Our Developers Are Mastered in Nuxt Through Comprehensive Training
          </p>
            <LazyHydrationWrAnimatedTraining :content="'nuxt'" :hydrate-on-visible="{ rootMargin: '100px' }"/>
        </div>
        <div class="overflow-x-auto w-full px-4 no-scrollbar">
          <div class="flex gap-6 mt-16 mx-auto max-w-max">
            <LazyHydrationWrDeveloper :dev-info="devInfo" :hydrate-on-visible="{ rootMargin: '100px' }"/>
          </div>
        </div>
        <WrButton container-class="mx-auto mt-12" @click="handleButtonClick"
          >Interview a Developer</WrButton
        >
      </section>

      <!-- Section 3: IT Staff Augmentation -->
      <section
        class="relative z-10 pb-20 lg:pb-36 overflow-hidden grid place-items-center"
        :class="selectedTab[2] ? 'order-1' : 'order-5'"
        id="`panel-2`"
        role="tabpanel"
        :aria-labelledby="`tab-2`"
      >
        <div class="max-w-screen-xl mx-auto px-4 w-full">
          <h3 class="text-center mb-0 lg:mb-11">
            <WrGradientText
              text="IT Staff Augmentation"
              append-class="text-5xl lg:text-[120px] bg-[image:var(--text-secondary-gradient)]"
            />
          </h3>
          <div class="flex flex-col lg:flex-row gap-10 justify-between">
            <div class="mt-4 max-lg:text-center">
              <p class="text-3xl md:text-[3rem] md:min-w-max leading-tight">
                Your Partner in <br class="max-md:hidden" />
                Workforce Growth
              </p>
              <p class="text-medium md:mt-3 tracking-[0.5px]">
                Optimize Costs and Streamline Workforce
              </p>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 text-white">
              <div
                v-for="item in staffAchivements"
                class="bg-[image:var(--border-staff-card)] rounded-xl p-px h-full text-white"
              >
                <div
                  class="py-6 px-4 rounded-xl text-center bg-[image:var(--bg-staff-card)] h-full"
                >
                  <p class="font-semibold text-5xl mdtext-6xl mb-2">
                    {{ item.count }}
                  </p>
                  <p class="text-medium md:text-lg line-clamp-3">
                    {{ item.title }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="grid sm:grid-cols-2 lg:grid-cols-4 my-12 gap-y-4">
            <div
              v-for="item in staffSpecs"
              class="flex gap-7 px-7 py-5 border-l border-[var(--color-10)] relative after:content-[''] after:absolute after:top-6 after:-left-px after:w-px after:h-4 after:bg-[var(--color-11)]"
            >
             <WrSVGIcon :class="item.appendClass" :name="item.svg" class="shrink-0 text-[#7758AE] dark:text-[var(--foreground)]"/>
              <p
                class="text-sm text-[var(--foreground)] dark:text-[var(--primary)] tracking-[0.5px]"
              >
                {{ item.title }}
              </p>
            </div>
          </div>

          <LazyHydrationWrFromAugmentation @formSubmitted="openModal" :hydrate-on-visible="{ rootMargin: '100px' }"/>
        </div>
      </section>

      <section
        class="relative pb-10 lg:pb-24 overflow-visible grid place-items-center order-6"
      >
        <div
          v-if="$colorMode.preference == 'dark'"
          class="absolute w-[2266px] h-[1241px] top-20 rounded-[100%] bg-[linear-gradient(0deg,_#1F013405_31.11%,_#4D27B600_51.33%,_#855BF200_57.98%,_#22206D20_62.05%)] dark:bg-[linear-gradient(0deg,_#1F0134_31.11%,_#4D27B600_51.33%,_#855BF200_57.98%,_#22206D_62.05%)] blur-[100px] dark:blur-[100px]"
        >
          <div
            class="w-[2260px] h-[1440px] bg-white dark:bg-[var(--color-5)] rounded-[100%] absolute top-[200px] left-0"
          ></div>
        </div>
        <NuxtImg
          v-if="$colorMode.preference != 'dark'"
          src="/images/cms-back-laravel.webp"
          class="absolute -top-96 left-1/2 -translate-x-1/2 min-w-[3745px] min-h-[2349]"
          width="3745"
          height="2349"
          alt="cms-back"
          loading="lazy"
          format="webp"
        />

        <div class="rising-stars top-0">
          <div style="height: 4px; width: 4px"></div>
          <div style="height: 2px; width: 2px"></div>
          <div style="height: 1px; width: 1px"></div>
        </div>

        <div
          class="max-w-screen-xl mx-auto px-4 w-full grid md:grid-cols-2 gap-6 relative z-10"
        >
          <div class="max-md:text-center mx-auto max-w-[504px]">
            <h3>
              <WrGradientText
                text="Get all your questions"
                append-class="py-0 md:py-4"
              />
              <span>answered here</span>
            </h3>
            <p class="mt-5 pr-4 text-lg tracking-[0.5px]">
              Here are some frequently asked questions about Nuxt and our
              process for <strong> Nuxt development</strong>.
            </p>
            <ul
              class="mt-8 list-disc max-md:gap-y-4 max-md:max-w-max max-md:mx-auto max-md:grid max-md:grid-cols-2 text-[var(--secondary-foreground)] md:space-y-4 list-inside text-left"
            >
              <li
                v-for="(item, index) in items"
                :key="index"
                @click="setActive(index)"
                :class="{
                  'cursor-pointer': true,
                  active: activeIndex === index,
                }"
              >
                {{ item }}
              </li>
            </ul>
            <WrButton
              container-class="mt-8 max-md:mx-auto"
              @click="handleButtonClick"
              >Connect with us</WrButton
            >
          </div>
          <div class="grow">
            <LazyHydrationWrAccordion :Content="filteredAccordionContent" :hydrate-on-visible="{ rootMargin: '100px' }"/>
          </div>
        </div>
      </section>

      <section
        class="relative z-10 py-10 lg:pb-20 grid place-items-center order-7"
      >
        <div class="max-w-screen-lg mx-auto overflow-hidden px-4">
          <h4 class="text-center">
            <WrGradientText
              text="Accelerate Release"
              append-class="py-0 md:py-4"
            />
            <p class="">and Maintain Excellence</p>
          </h4>
          <p class="text-lg text-center mb-10 mt-4 tracking-[0.5px]">
            100% Risk-Free with a 1-Week Trial Period—Shortlist and Hire the
            Right Developer
          </p>
        </div>
        <div class="overflow-x-auto w-full px-4 pt-12 no-scrollbar">
          <LazyHydrationWrPricing
            :pricing-content="pricingContent"
            class="w-full"
            @openPopup="openWithEmitVariable"
            :hydrate-on-visible="{ rootMargin: '100px' }"
          />
        </div>
      </section>

      <section
        class="relative z-20 py-10 lg:pb-40 overflow-hidden grid place-items-center order-8"
      >
        <div class="max-w-screen-xl mx-auto px-4 w-full">
          <h4 class="text-center">
            <WrGradientText
              text="Begin upgrading"
              append-class="py-0 md:py-4"
            />
            <p class="">your web application with us.</p>
          </h4>
          <p class="text-lg text-center mb-8 md:mb-20 mt-7 tracking-[0.5px]">
            Let us manage while you relax.
          </p>
          <LazyHydrationWrTechUpgrade
            :pre-ver="preVer"
            :latest-ver="latestVer"
            :old-version="oldVersion"
            :new-version="newVersion"
            :hydrate-on-visible="{ rootMargin: '100px' }"
          />
        </div>
      </section>

      <section class="relative z-10 py-10 lg:pb-28 overflow-visible order-9">
        <div class="max-w-screen-lg mx-auto px-4 w-full relative">
          <div
            class="hidden dark:block opacity-30 md:size-[764px] rounded-full bg-[linear-gradient(136.28deg,_rgba(51,4,79,0)_30.43%,_#260049_54.53%,_#36006F_92.37%)] absolute -top-[30%] -left-[67%]"
          ></div>

          <div
            class="hidden dark:block opacity-50 size-[190px] rounded-full bg-[image:var(--bg-circle-top-light)] absolute -bottom-[15%] right-0 top-0"
          ></div>
          <LazyHydrationWrSelectedProject :hydrate-on-visible="{ rootMargin: '100px' }"/>
        </div>
      </section>
      <section
        class="relative z-10 py-10 lg:pb-32 overflow-hidden grid place-items-center order-10"
      >
        <div class="max-w-screen-xl mx-auto px-4 w-full">
          <h5 class="text-center">
            <WrGradientText text="Why outsource to India?" />
          </h5>
          <div class="grid md:grid-cols-2 gap-8 max-w-max mx-auto mt-10">
            <div v-for="reason in outsource" class="flex items-center gap-5">
              <div
                class="p-px bg-[#957EFF] dark:bg-transparent dark:bg-[image:var(--border-form-card)] rounded-full"
              >
                <div
                  class="size-16 md:size-20 rounded-full bg-white dark:bg-[#200945] grid place-items-center text-2xl"
                >
                  {{ reason.id }}.
                </div>
              </div>
              <p
                v-html="reason.text"
                class="md:text-base tracking-[0.5px] text-[var(--secondary-foreground)]"
              ></p>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section
      class="relative py-10 lg:py-20 overflow-hidden max-w-screen-xl mx-auto px-4 z-20"
    >
      <h5 class="text-center">
        <WrGradientText text="Trusted for excellence and efficiency" />
      </h5>
      <p
        class="text-lg text-[var(--foreground)] mb-10 text-center tracking-[0.5px]"
      >
        WebReinvent is trusted by leading organisations to enhance their
        development and operational efficiency.
      </p>
      <!-- Carousel Section -->

      <LazyHydrationWrTestimonialCardCarousel  />

      <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-2"
        >View All</WrButton
      >
    </section>
  </div>
  <LazyWrContactFormPopup
    v-if="visible"
    :isOpen="visible"
    @close="visible = false"
    class="z-30"
    :prefilledContent="formPrefilledData"
  />
</template>
